// extracted by mini-css-extract-plugin
export default {"toggleSwitchContainer":"style_toggleSwitchContainer__qnHVK","logosContainer":"style_logosContainer__cTL9d","logoContainer":"style_logoContainer__sMzy8"};